import { FormNames, IFormDefinition } from 'models/Form/FormModels'
import { basicInfoFields } from './BasicInfoFields'
import { AppLinks } from 'enviroment/AppLinks'

export const basicInfoForm: IFormDefinition = {
   name: FormNames.BasicInfo,
   fields: basicInfoFields,
   labelTextContentPath: "basicInfoFormPage.label",
   urlPath: AppLinks.basicInfoForm,
   nextStepUrlPath: AppLinks.addressInfoForm,
   canStepBack: true,
   previousStepUrlPath: AppLinks.chooseIdentityMethod,
   subbmitButtonTextContentPath: "basicInfoFormPage.subbmitButtonText"
}